<app-modal
  #modal
  [modalConfig]="{
    headerClass: ['visually-hidden'],
    hideDismissButton: true,
    options: { size: 'fullscreen' }
  }">
  <app-form-view [showTitle]="true" *ngIf="form" [form]="form"></app-form-view>
</app-modal>
